(() => {
  const bar = document.querySelector('[data-kal-sticky-atc]');
  if (!bar) return;

  const stickyForm = bar.querySelector('form');
  const stickyId = stickyForm?.querySelector('input[name="id"]');
  const stickyQuantity = stickyForm?.querySelector('[data-kal-sticky-quantity]');
  const stickyButton = stickyForm?.querySelector('button[name="add"]');
  const stickyVariant = bar.querySelector('[data-kal-sticky-variant]');
  const stickyImage = bar.querySelector('.kal-sticky-atc__image');
  const threshold = Number(bar.dataset.showAfter) || 600;
  const mainProductInfo = Array.from(document.querySelectorAll('product-info[data-product-id]'))
    .find((element) => element.dataset.productId === bar.dataset.productId);
  const primaryForm = mainProductInfo?.querySelector('form[id^="product-form-"]');
  const primaryButton = primaryForm?.querySelector('.product-form__buttons button[name="add"]');
  const priceTarget = bar.querySelector('[data-kal-sticky-price]');
  const mainPrice = mainProductInfo?.querySelector('.price');
  let syncingQuantity = false;

  const getPrimaryQuantity = () => Array.from(document.querySelectorAll('input[name="quantity"]'))
    .find((input) => input.form === primaryForm || input.getAttribute('form') === primaryForm?.id || primaryForm?.contains(input));
  const setVisible = (visible) => {
    bar.hidden = !visible;
    bar.classList.toggle('is-visible', visible);
  };
  const syncVariant = () => {
    const mainId = primaryForm?.querySelector('input[name="id"]');
    if (mainId && stickyId) stickyId.value = mainId.value;
    const mainQuantity = getPrimaryQuantity();
    if (mainQuantity && stickyQuantity && document.activeElement !== stickyQuantity) stickyQuantity.value = mainQuantity.value || '1';
    if (mainPrice && priceTarget) priceTarget.textContent = mainPrice.innerText.trim();
    if (primaryButton && stickyButton) stickyButton.disabled = primaryButton.disabled;
  };
  const update = () => {
    syncVariant();
    const target = primaryButton || mainProductInfo;
    const rect = target?.getBoundingClientRect();
    const isInView = rect ? rect.bottom > 0 && rect.top < window.innerHeight : window.scrollY < threshold;
    setVisible(window.scrollY >= threshold && !isInView);
  };
  const syncQuantity = (event) => {
    const source = event.target;
    if (syncingQuantity || !(source instanceof HTMLInputElement) || source.name !== 'quantity') return;
    const primaryQuantity = getPrimaryQuantity();
    if (source !== primaryQuantity && source !== stickyQuantity) return;
    const target = source === stickyQuantity ? primaryQuantity : stickyQuantity;
    if (!target || target.value === source.value) return;
    syncingQuantity = true;
    target.value = source.value;
    target.dispatchEvent(new Event('input', { bubbles: true }));
    target.dispatchEvent(new Event('change', { bubbles: true }));
    syncingQuantity = false;
  };
  let ticking = false;
  const scheduleUpdate = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => { update(); ticking = false; });
  };

  document.addEventListener('input', syncQuantity);
  document.addEventListener('change', (event) => {
    syncQuantity(event);
    scheduleUpdate();
  });
  stickyVariant?.addEventListener('click', () => mainProductInfo?.scrollIntoView({ behavior: 'smooth', block: 'center' }));
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      if (!data?.variant || String(data.sectionId) !== String(mainProductInfo?.dataset.section)) return;
      if (stickyVariant) stickyVariant.textContent = data.variant.title;
      if (data.variant.featured_image?.src && stickyImage) stickyImage.src = data.variant.featured_image.src;
      scheduleUpdate();
    });
  }
  window.addEventListener('scroll', scheduleUpdate, { passive: true });
  window.addEventListener('resize', scheduleUpdate, { passive: true });
  update();
})();